export default "__VITE_ASSET__BHRAkbJB__"